
import Vue from "vue";
import { api, SpendingDecisionState } from "@/services/api";
import { handleLoginCheck } from "@/services/loginChecker";
import PurchaseAdvisor from "@/components/PurchaseAdvisor.vue";

export default Vue.extend({
    components: { PurchaseAdvisor },
    props: {
        embedded: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            state: null as SpendingDecisionState | null,
            summary: "",
            draftNotes: "",
            lastSavedDraft: "",
            saving: false
        };
    },
    computed: {
        draftDirty(): boolean {
            return this.draftNotes !== this.lastSavedDraft;
        },
        formattedUpdatedAt(): string {
            if (!this.state?.updatedAt) {
                return "";
            }
            return new Date(this.state.updatedAt).toLocaleString();
        }
    },
    async mounted() {
        await handleLoginCheck(this.$router);
        await this.refresh();
    },
    methods: {
        async refresh() {
            const state = await api.getSpendingDecisions();
            if (!state) {
                return;
            }
            this.state = state;
            this.summary = state.summary || "";
            this.draftNotes = state.draftNotes || "";
            this.lastSavedDraft = this.draftNotes;
        },
        async saveDraft() {
            this.saving = true;
            try {
                const state = await api.saveSpendingDecisionDraft(this.draftNotes);
                if (state) {
                    this.state = state;
                    this.lastSavedDraft = state.draftNotes || "";
                    this.draftNotes = this.lastSavedDraft;
                    this.summary = state.summary || "";
                }
            } finally {
                this.saving = false;
            }
        },
        async persistSummary() {
            this.saving = true;
            try {
                const state = await api.persistSpendingDecisionSummary(this.summary);
                if (state) {
                    this.state = state;
                    this.summary = state.summary || "";
                    this.draftNotes = state.draftNotes || "";
                    this.lastSavedDraft = this.draftNotes;
                }
            } finally {
                this.saving = false;
            }
        },
        async clearDraft() {
            this.draftNotes = "";
            await this.saveDraft();
        }
    }
});
